<!--  -->
<template>
  <div class="drawer-layout">
    <el-tabs v-model="activeName" tab-position="left">
      <el-tab-pane name="first" label="常规" v-if="showCommon">
        <slot name="first"></slot>
      </el-tab-pane>
      <el-tab-pane label="栏目" name="second" v-if="showColumn">
        <slot name="second"></slot>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>

export default {
  components: {},
  data () {
    return {
      activeName: 'first'
    }
  },
  props: {
    showColumn: {
      type: Boolean,
      default: true
    },
    showCommon: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    activeName: {
      immediate: true,
      handler (val) {
        this.$emit('upSelected', val)
      }
    }
  },
  created () {
    if (!this.showCommon) {
      this.activeName = 'second'
    }
  }
}
</script>
<style lang='scss' scoped>
::v-deep .el-tabs {
  height: 537px;
  .el-tabs__header {
    margin-right: 16px;
    .el-tabs__nav-wrap {
      border-right: 1px solid rgba(245, 246, 247, 1);
      z-index: 2;
      &::after {
        width: 0px !important;
      }
    }
    .el-tabs__nav {
      margin-top: 8px;
      .el-tabs__active-bar {
        width: 2px;
        left: 0;
        border-radius: 0 3px 3px 0;
        height: 16px !important;
        top: 6px;
      }
      .is-active {
        background: rgba(245, 250, 255, 1);
        color: rgba(1, 25, 51, 1) !important;
      }
      .el-tabs__item {
        font-size: 14px;
        height: 28px;
        line-height: 28px;
        padding: 0 20px 0 12px;
        font-family: MicrosoftYaHei;
        color: rgba(153, 163, 173, 1);
      }
    }
  }
  .el-tabs__content {
    margin-top: 10px;
    font-size: 12px;
  }
}
</style>
